import React from "react";
import {TimeLineEvent, TimeLineItem, TimeLineItemDate} from "domains/Request/component/shared/MainStyles"


interface ITimeLineEventItem {
  date: string;
  time?: string;
  event?: React.ReactNode | React.ReactElement;
  dotColor?: string;
}

export default function TimeLineEventItem({ date, time="", event ="", dotColor = "#399ebf" }: ITimeLineEventItem) {
  return (
      <TimeLineItem color={dotColor}>
        <TimeLineItemDate>{date} {time}</TimeLineItemDate>
        <TimeLineEvent>
          {event}
        </TimeLineEvent>
      </TimeLineItem>
  );
}
